module.exports = __webpack_public_path__ + "e77d8c6c0603611cfdd1c7d749859993.svg";